(ns dre.i18n.utils
  (:require
   [applied-science.js-interop :as j]
   [clojure.string :as str]
   [reagent.format :refer [format]]))


(defn decide-language
  [& {:keys [preferred supported default]}]
  (let [browser-lang (->> (j/get js/navigator :language "")
                          (re-find #"^\w{2}")
                          supported)]
    (or preferred browser-lang default)))


(defn tr-later
  "Identity function serving to mark translatable messages for collecting."
  [msg]
  msg)

(defn translate
  ([state msg]
   (translate state msg nil))
  ([{:keys [language messages]} msg format-args]
   (let [translation (get-in messages [msg language])]
     (apply format
            (if (str/blank? translation) msg translation)
            format-args))))
